module.exports = __webpack_public_path__ + "static/the-white-album-952aee749f3542c86cbb624305faad0d.jpg";